import { Link as RouterLink } from "react-router-dom";

export default function ThankYouPage() {
   return (
      <div className="min-h-screen flex items-center justify-center bg-white p-6">
         {/* Card */}
         <div
            className="
          w-full max-w-[574px]           /* Figma width */
          bg-white rounded-xl           /* 12px radius */
          px-12 py-10                   /* 48px × 40px padding */
          flex flex-col gap-12          /* 48px vertical gap */
        "
         >
            {/* Headings */}
            <h1 className="text-[40px] leading-[45px] text-custom-dark">
               What’s next?
            </h1>
            <h2 className="text-[40px] leading-[45px] text-custom-dark/50">
               We’ll be in touch.
            </h2>

            {/* Body copy */}
            <p className="text-[16px] leading-[172%] text-custom-dark/70 max-w-[510px]">
               We’ll review your request and will get in touch for next steps or
               if we need more detail. In the meantime, we’ve sent your proposal
               details to your email – you should receive them within a few
               minutes.
            </p>

            {/* Button */}
            <RouterLink
               to="/"
               className="
            block w-full
            py-4                         /* 56px height */
            bg-custom-dark               /* brand dark blue */
            text-white
            text-[16px] leading-[28px]
            rounded-[40px]               /* 40px radius */
            text-center
            transition-colors duration-200
            hover:bg-custom-dark/90
          "
            >
               Return to Homepage
            </RouterLink>
         </div>
      </div>
   );
}
